// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__CxCOJ","ranges":"BmiRanges_ranges__2qnps"};